/**
 * Class description
 *
 * Created: 2017-09-25
 * @author jonas
 */
interface StateOffsetDictionary {
    default:[number, number];

    [index:string]:[number, number];
}

interface OffsetConfig {
    [index:string]:StateOffsetDictionary;
}


export class TeslaSymbols {

    public static L1:string = "L1";
    public static L2:string = "L2";
    public static L3:string = "L3";
    public static L4:string = "L4";
    public static L5:string = "L5";
    public static M1:string = "M1";
    public static M2:string = "M2";
    public static M3:string = "M3";
    public static M4:string = "M4";
    public static W:string = "W";
    public static W2:string = "W2";
    public static B:string = "B";
    public static B2:string = "B2";
    public static S:string = "S";

    public static OFFSET_CONFIG:OffsetConfig = {
        [TeslaSymbols.L1] : {default : [0, 0], "win" : [1, 1]},
        [TeslaSymbols.L2] : {default : [0, 0]},
        [TeslaSymbols.L3] : {default : [0, 0]},
        [TeslaSymbols.L4] : {default : [0, 0]},
        [TeslaSymbols.L5] : {default : [0, 0]},
        [TeslaSymbols.M1] : {default : [0, 0]},
        [TeslaSymbols.M2] : {default : [0, 0]},
        [TeslaSymbols.M3] : {default : [0, 0]},
        [TeslaSymbols.M4] : {default : [0, 0]},
        [TeslaSymbols.B] : {default : [0, 0]},
        [TeslaSymbols.B2] : {default : [10, -34], "win" : [18, -44]},
        [TeslaSymbols.W] : {default : [0, -6], "attention" : [4, 0]},
        [TeslaSymbols.W2] : {default : [0, -6], "attention" : [4, 0]},
        [TeslaSymbols.S] : {default : [0, 0]}
    };

    public static offset(symName:string, stateKey:string):[number, number] {
        const stateOffsetDictionary:StateOffsetDictionary = TeslaSymbols.OFFSET_CONFIG[symName];
        if(stateOffsetDictionary[stateKey]) {
            return stateOffsetDictionary[stateKey];
        }
        return stateOffsetDictionary.default;
    }

}